import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const REDIRECT_SECONDS = 60;

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [remaining, setRemaining] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (remaining <= 0) {
      navigate("/", { replace: true });
      return;
    }
    const id = setTimeout(() => setRemaining((s) => s - 1), 1000);
    return () => clearTimeout(id);
  }, [remaining, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f9fafb",
        fontFamily: "sans-serif",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "1rem",
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          padding: "3rem 4rem",
          maxWidth: 480,
          width: "100%",
        }}
      >
        <div style={{ fontSize: "5rem", lineHeight: 1, marginBottom: "1rem" }}>
          404
        </div>
        <h1
          style={{
            fontSize: "1.5rem",
            fontWeight: 700,
            color: "#111827",
            margin: "0 0 0.5rem",
          }}
        >
          Page Not Found
        </h1>
        <p style={{ color: "#6b7280", marginBottom: "2rem" }}>
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Countdown ring */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "2rem",
            gap: "0.5rem",
          }}
        >
          <svg width={80} height={80} viewBox="0 0 80 80">
            <circle
              cx={40}
              cy={40}
              r={34}
              fill="none"
              stroke="#e5e7eb"
              strokeWidth={6}
            />
            <circle
              cx={40}
              cy={40}
              r={34}
              fill="none"
              stroke="#4f46e5"
              strokeWidth={6}
              strokeLinecap="round"
              strokeDasharray={`${2 * Math.PI * 34}`}
              strokeDashoffset={`${
                2 * Math.PI * 34 * (1 - remaining / REDIRECT_SECONDS)
              }`}
              transform="rotate(-90 40 40)"
              style={{ transition: "stroke-dashoffset 0.9s linear" }}
            />
            <text
              x={40}
              y={45}
              textAnchor="middle"
              fontSize={22}
              fontWeight={700}
              fill="#4f46e5"
            >
              {remaining}
            </text>
          </svg>
          <span style={{ color: "#6b7280", fontSize: "0.875rem" }}>
            Redirecting to home in {remaining}s
          </span>
        </div>

        <button
          onClick={() => navigate("/", { replace: true })}
          style={{
            background: "#4f46e5",
            color: "#fff",
            border: "none",
            borderRadius: "0.5rem",
            padding: "0.625rem 1.5rem",
            fontSize: "1rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Go Home Now
        </button>
      </div>
    </div>
  );
}
